export function uniqueID(prefix, excludes) {
    let id = `${prefix}0`;
    //Check for unique id
    for(let index = 0; index < excludes.length; index++){
        const newId = `${prefix}${index + 1}`;
        if (!excludes.some((val)=>val.toLowerCase() === newId.toLowerCase())) {
            //case insensitive check was failing for newly created item like 'Subgraph_x' if there is already 'subgraph_x'/ 'SubGraph_x' in the list
            id = newId;
            break;
        }
    }
    return id;
}
